import { AddOutlined, DeleteOutlined, EditOutlined, UndoOutlined, UploadFileOutlined } from "@mui-symbols-material/w300"

import type { GoodsReceiptHeaderActionsByStatus } from "../types"

import type { GoodsReceipt } from "@/graphql/codegen/graphql"
import { GoodsReceiptStatus } from "@/graphql/codegen/graphql"

interface UseGoodsReceiptHeaderActionsProps {
  goodsReceipt: GoodsReceipt
  onEdit?: (goodsReceipt: GoodsReceipt) => void
  onDelete?: (goodsReceipt: GoodsReceipt) => void
  onCreatePallets?: () => void
  onUpload?: () => void
  onMarkAsNotReceived?: (goodsReceipt: GoodsReceipt) => void
  onClose: () => void
}

export const useGoodsReceiptHeaderActions = ({
  goodsReceipt,
  onEdit,
  onDelete,
  onCreatePallets,
  onUpload,
  onMarkAsNotReceived,
  onClose,
}: UseGoodsReceiptHeaderActionsProps): GoodsReceiptHeaderActionsByStatus[string] => {
  const uploadAction = {
    label: "Upload File",
    testId: "upload-menu-item",
    icon: <UploadFileOutlined sx={{ fontVariationSettings: '"wght" 300' }} />,
    handler: () => {
      onClose()
      onUpload?.()
    },
    isHidden: !onUpload,
  }

  const statusActionsMap: GoodsReceiptHeaderActionsByStatus = {
    [GoodsReceiptStatus.Incoming]: [
      {
        label: "Edit",
        testId: "edit-menu-item",
        icon: <EditOutlined sx={{ fontVariationSettings: '"wght" 300' }} />,
        handler: () => {
          onClose()
          onEdit?.(goodsReceipt)
        },
        isHidden: !onEdit,
      },
      {
        label: "Delete",
        testId: "delete-menu-item",
        icon: <DeleteOutlined sx={{ fontVariationSettings: '"wght" 300' }} />,
        handler: () => {
          onClose()
          onDelete?.(goodsReceipt)
        },
        isHidden: !onDelete,
      },
    ],
    [GoodsReceiptStatus.SoftReceived]: [
      {
        label: "Edit",
        testId: "edit-menu-item",
        icon: <EditOutlined sx={{ fontVariationSettings: '"wght" 300' }} />,
        handler: () => {
          onClose()
          onEdit?.(goodsReceipt)
        },
        isHidden: !onEdit,
      },
      {
        label: "Mark as Not Received",
        testId: "mark-as-not-received-menu-item",
        icon: <UndoOutlined sx={{ fontVariationSettings: '"wght" 300' }} />,
        handler: () => {
          onClose()
          onMarkAsNotReceived?.(goodsReceipt)
        },
        isHidden: !onMarkAsNotReceived,
      },
    ],
    [GoodsReceiptStatus.CheckedIn]: [
      {
        label: "Add Pallets",
        testId: "create-pallets-menu-item",
        icon: <AddOutlined sx={{ fontVariationSettings: '"wght" 300' }} />,
        handler: () => {
          onClose()
          onCreatePallets?.()
        },
        isHidden: !onCreatePallets,
      },
    ],
    [GoodsReceiptStatus.Stored]: [],
  }

  const baseActions = statusActionsMap[goodsReceipt.status]?.filter((action) => action.isHidden !== true) || []
  return onUpload ? [...baseActions, uploadAction] : baseActions
}
